<template>
  <section id="dashboard" class="container">
    <ul class="page-title px-4 px-xl-2">
      <router-link tag="li" :to="{ name: 'Admin Gallery' }">
        <h1><a>Gallery</a></h1>
      </router-link>
      <router-link tag="li" :to="{ name: 'Admin Websites' }">
        <h1><a>Websites</a></h1>
      </router-link>
      <router-link tag="li" :to="{ name: 'Admin Case Sudies' }">
        <h1><a>Case Studies</a></h1>
      </router-link>
    </ul>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#dashboard {
  display: flex;
  min-height: 100vh;
  align-items: center;
  justify-content: center;

  ul {
    list-style: none;
    margin: 15vh;
    text-align: center;

    li {
      margin-bottom: 60px;

      a {
        color: whitesmoke;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
